import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import {
  getTheme2MultiSelectCss,
  getTheme2SearchFilterFieldCss,
  getTheme2SearchFilterStatusFieldCss,
  THEME2_SEARCH_FILTER_ACCOUNTS_WIDE_FIELD_WIDTH,
} from "utils/theme2MultiSelect";
import { getStickyStockTableStickyColumnCss } from "utils/reactTableTheme";

const SEARCH_ACCOUNTS_STATUS_PREFIX = "search-accounts-status";
const SEARCH_ACCOUNTS_LOCATION_PREFIX = "search-accounts-location";

const SEARCH_ACCOUNTS_PAGE_STYLES = (isTheme2) => `
  ${isTheme2 ? `
  .search-accounts.search-accounts--theme2 .search-accounts-table-card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 0 !important;
  }
  ${getTheme2SearchFilterFieldCss({
    pageScopeSelector: ".search-accounts.search-accounts--theme2",
    filtersSelector: ".search-accounts-table-card .search-accounts-filters",
    rowClass: "search-accounts-filters-row",
    colClass: "search-accounts-filter-col",
  })}
  ${getTheme2SearchFilterStatusFieldCss({
    pageScopeSelector: ".search-accounts.search-accounts--theme2",
    filterColClass: "search-accounts-filter-col",
    wideModifiers: ["status", "location"],
    fieldWidth: THEME2_SEARCH_FILTER_ACCOUNTS_WIDE_FIELD_WIDTH,
  })}
  .search-accounts.search-accounts--theme2 .search-accounts-filters-row {
    column-gap: 4px;
  }
  .search-accounts.search-accounts--theme2 .search-accounts-filter-col {
    padding-left: 4px;
    padding-right: 4px;
  }
  .search-accounts.search-accounts--theme2 .search-accounts-filter-col:first-child {
    padding-left: 0;
  }
  ${getTheme2MultiSelectCss({
    prefix: SEARCH_ACCOUNTS_STATUS_PREFIX,
    pageScopeSelector: ".search-accounts.search-accounts--theme2",
  })}
  ${getTheme2MultiSelectCss({
    prefix: SEARCH_ACCOUNTS_LOCATION_PREFIX,
    pageScopeSelector: ".search-accounts.search-accounts--theme2",
  })}
  ` : ""}
  .search-accounts-card-header.card-header {
    padding-top: 2px;
    padding-bottom: 0;
  }
  .search-accounts-card-header h2,
  .search-accounts-card-header h4 {
    font-size: 16px !important;
    margin-top: 10px;
    margin-bottom: 0;
    line-height: 1.2;
  }
  .search-accounts:not(.search-accounts--theme2) .card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 10px !important;
  }
  .sticky-stock-table .rt-table {
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) {
    text-align: center !important;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child {
    text-align: right !important;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) .rt-resizable-header-content {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child).-cursor-pointer .rt-resizable-header-content {
    padding-right: 2em;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child .rt-resizable-header-content {
    text-align: right;
    width: 100%;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) {
    text-align: center;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:last-child {
    text-align: right;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) > * {
    max-width: 100%;
    min-width: 0;
  }
  ${getStickyStockTableStickyColumnCss()}
`;

const AccountsCards = ({ isTheme2, filters, table, tableHeader, title }) => {
  const { t } = useTranslation();
  const pageTitle = title ?? t("accounts.title");

  const titleHeader = (
    <CardHeader className="search-accounts-card-header">
      <h2 className="mb-0">{pageTitle}</h2>
    </CardHeader>
  );

  return (
    <>
      <style>{SEARCH_ACCOUNTS_PAGE_STYLES(isTheme2)}</style>
      {isTheme2 ? (
        <Card className="search-accounts-table-card">
          {titleHeader}
          <CardBody>
            <div className="search-accounts-filters">{filters}</div>
            {table}
          </CardBody>
        </Card>
      ) : (
        <>
          <Card>
            {titleHeader}
            <CardBody>{filters}</CardBody>
          </Card>
          <Card className="mt-2">
            {tableHeader ? <CardHeader>{tableHeader}</CardHeader> : null}
            <CardBody>{table}</CardBody>
          </Card>
        </>
      )}
    </>
  );
};

export default AccountsCards;
